import { GENERAL_VARIABLE_DATA } from '../general/general.data';
import { QUESTIONNAIRE_NOURISH_DATA } from '../nourish/nourish.data';
import { QuestionnaireTenxData } from './tenx.interface';

export const QUESTIONNAIRE_TENX_DATA: QuestionnaireTenxData = {
  surgicalHistory: {
    title: 'Surgical History',
    fieldName: 'surgicalHistory',
    showSearch: true,
    showOtherInput: true,
    placeholderOther: 'Other Surgical History',
    options: [
      {
        id: '1',
        name: 'None',
        value: 'None',
        type: ['SURGICAL'],
        isDefault: true
      },
      ...(GENERAL_VARIABLE_DATA.healthMedicalHistories?.options ?? [])
        .filter((item) => item.type?.includes('SURGICAL'))
        .map((item, index) => ({
          ...item,
          id: `${item.id ?? index + 1}`
        }))
    ]
  },
  medications: {
    title: 'Medication History',
    fieldName: 'medications',
    showSearch: true,
    placeholderOther: 'Other Medication',
    options: [
      { id: '1', name: 'None', value: 'None', isDefault: true },
      {
        id: '2',
        name: 'Blood Pressure Medication',
        description: '(e.g., beta blockers, ACE inhibitors)',
        value: 'Blood Pressure Medication'
      },
      {
        id: '3',
        name: 'Cholesterol Medication',
        description: '(e.g., statins)',
        value: 'Cholesterol Medication'
      },
      {
        id: '4',
        name: 'Blood Thinners',
        description: '(e.g., warfarin, aspirin)',
        value: 'Blood Thinners'
      },
      {
        id: '5',
        name: 'Diabetes Medication',
        description: '(e.g., insulin, metformin)',
        value: 'Diabetes Medication'
      },
      {
        id: '6',
        name: 'Kidney Support Medication',
        description: '(e.g., diuretics, phosphate binders)',
        value: 'Kidney Support Medication'
      },
      {
        id: '7',
        name: 'Pain Relievers',
        description: '(e.g., NSAIDs, acetaminophen)',
        value: 'Pain Relievers'
      },
      {
        id: '8',
        name: 'Anti-Inflammatory Medication',
        description: '(e.g., corticosteroids)',
        value: 'Anti-Inflammatory Medication'
      },
      {
        id: '9',
        name: 'Antidepressants or Anti-Anxiety Medication',
        description: '',
        value: 'Antidepressants or Anti-Anxiety Medication'
      },
      {
        id: '10',
        name: 'Neurodegenerative Support Medication',
        description: "(e.g., dopamine agonists for Parkinson's)",
        value: 'Neurodegenerative Support Medication'
      },
      {
        id: '11',
        name: 'Hormone Therapy',
        description: '(e.g., estrogen, testosterone)',
        value: 'Hormone Therapy'
      },
      {
        id: '12',
        name: 'Sleep Aids',
        description: '(e.g., melatonin, prescription sleep aids)',
        value: 'Sleep Aids'
      },
      {
        id: '13',
        name: 'Contraception',
        description: '',
        value: 'Contraception'
      }
    ]
  },
  vaccinations: {
    title: 'Vaccination Status',
    fieldName: 'vaccinations',
    showSearch: true,
    showOtherInput: true,
    placeholderOther: 'Other Vaccination',
    options: [
      { id: '1', name: 'None', value: 'None' },
      {
        id: '2',
        name: 'Polio Vaccine',
        value: 'Polio Vaccine',
        isDefault: true
      },
      { id: '3', name: 'Hepatitis B Vaccine', value: 'Hepatitis B Vaccine' },
      {
        id: '4',
        name: 'BCG Vaccine (TB Vaccination)',
        value: 'BCG Vaccine (TB Vaccination)'
      },
      {
        id: '5',
        name: 'DPT (Difteri, Pertusis, Tetanus) Vaccine',
        value: 'DPT (Difteri, Pertusis, Tetanus) Vaccine',
        isDefault: true
      },
      {
        id: '6',
        name: 'Campak-Rubella Vaccine',
        value: 'Campak-Rubella Vaccine'
      },
      { id: '7', name: 'Pneumonia Vaccine', value: 'Pneumonia Vaccine' },
      {
        id: '8',
        name: 'Covid-19 Vaccine (1st Vaccine)',
        value: 'Covid-19 Vaccine (1st Vaccine)',
        isDefault: true
      },
      {
        id: '9',
        name: 'Covid-19 Vaccine (2nd vaccine)',
        value: 'Covid-19 Vaccine (2nd vaccine)',
        isDefault: true
      },
      {
        id: '10',
        name: 'Covid-19 Vaccine (Booster)',
        value: 'Covid-19 Vaccine (Booster)'
      }
    ]
  },
  allergies: {
    title: 'Food Allergies',
    fieldName: 'allergies',
    showSearch: true,
    showOtherInput: true,
    placeholderOther: 'Other Allergy',
    options: QUESTIONNAIRE_NOURISH_DATA.allergies?.options ?? []
  },
  conditionalAllergies: {
    title: 'Conditional Allergies',
    fieldName: 'conditionalAllergies',
    showSearch: true,
    showOtherInput: true,
    placeholderOther: 'Other Conditional Allergy',
    options: [
      { id: '1', name: 'None', value: 'None', isDefault: true },
      {
        id: '2',
        name: 'Exercise-Induced Anaphylaxis (EIA)',
        value: 'Exercise-Induced Anaphylaxis (EIA)'
      },
      {
        id: '3',
        name: 'Cold-Induced Urticaria',
        value: 'Cold-Induced Urticaria'
      },
      { id: '4', name: 'Dust', value: 'Dust' },
      {
        id: '5',
        name: 'Vibration-Induced Angioedema',
        value: 'Vibration-Induced Angioedema'
      },
      { id: '6', name: 'Allergy to Alcohol', value: 'Allergy to Alcohol' },
      { id: '7', name: 'Aquagenic Urticaria', value: 'Aquagenic Urticaria' },
      { id: '8', name: 'Solar Urticaria', value: 'Solar Urticaria' }
    ]
  },
  medicalHistory: {
    title: 'Medical History',
    fieldName: 'medicalHistory',
    showSearch: true,
    showOtherInput: true,
    placeholderOther: 'Other Medical History',
    options: (
      GENERAL_VARIABLE_DATA.healthMedicalHistories?.options ?? []
    ).filter(
      (i) =>
        (i.isDefault === false &&
          i.isContagious === false &&
          ['ILLNESS', 'DISEASE'].every((type) => i.type?.includes(type)) &&
          ['FATHER', 'MOTHER'].every((parent) =>
            i.applicableParent?.includes(parent)
          )) ||
        i.isDefault === true
    )
  },
  fatherMedicalHistory: {
    title: 'Father Medical History',
    fieldName: 'fatherMedicalHistory',
    showSearch: true,
    showOtherInput: true,
    placeholderOther: 'Other Medical History',
    options: (
      GENERAL_VARIABLE_DATA.healthMedicalHistories?.options ?? []
    ).filter(
      (i) =>
        (i.isDefault === false &&
          i.isContagious === false &&
          ['ILLNESS', 'DISEASE'].every((type) => i.type?.includes(type)) &&
          ['FATHER', 'MOTHER'].every((parent) =>
            i.applicableParent?.includes(parent)
          )) ||
        i.isDefault === true
    )
  },
  motherMedicalHistory: {
    title: 'Mother Medical History',
    fieldName: 'motherMedicalHistory',
    showSearch: true,
    showOtherInput: true,
    placeholderOther: 'Other Medical History',
    options: (
      GENERAL_VARIABLE_DATA.healthMedicalHistories?.options ?? []
    ).filter(
      (i) =>
        (i.isDefault === false &&
          i.isContagious === false &&
          ['ILLNESS', 'DISEASE'].every((type) => i.type?.includes(type)) &&
          ['FATHER', 'MOTHER'].every((parent) =>
            i.applicableParent?.includes(parent)
          )) ||
        i.isDefault === true
    )
  },
  exerciseLevelPerWeek: {
    title: 'Exercise Level per Week',
    fieldName: 'exerciseLevelPerWeek',
    options: GENERAL_VARIABLE_DATA.exerciseLevelPerWeek?.options ?? []
  },
  'sleepHabits.sleepEachNightOnAverage': {
    title: 'Daily Average Sleep',
    fieldName: 'sleepHabits.sleepEachNightOnAverage',
    options:
      GENERAL_VARIABLE_DATA['sleepHabits.sleepEachNightOnAverage']?.options ??
      []
  },
  'smokingHabits.smokingStatus': {
    title: 'Smoking Status',
    fieldName: 'smokingHabits.smokingStatus',
    options: GENERAL_VARIABLE_DATA['smokingHabits.smokingStatus']?.options ?? []
  },
  'smokingHabits.startSmoking': {
    title: 'Actively Smoking Date',
    fieldName: 'smokingHabits.startSmoking',
    options: GENERAL_VARIABLE_DATA['smokingHabits.startSmoking']?.options ?? []
  },
  'smokingHabits.dailyConsumption': {
    title: 'Smoking Quantity per Day',
    fieldName: 'smokingHabits.dailyConsumption',
    options:
      GENERAL_VARIABLE_DATA['smokingHabits.dailyConsumption']?.options ?? []
  },
  'smokingHabits.cigarettesType': {
    title: 'Type of Cigarettes usually used',
    fieldName: 'smokingHabits.cigarettesType',
    options:
      GENERAL_VARIABLE_DATA['smokingHabits.cigarettesType']?.options ?? []
  },
  'alcoholHabits.alcoholStatus': {
    title: 'Alcohol Consumptions',
    fieldName: 'alcoholHabits.alcoholStatus',
    options: GENERAL_VARIABLE_DATA['alcoholHabits.alcoholStatus']?.options ?? []
  },
  'alcoholHabits.startConsumeAlcohol': {
    title: 'Start Drinking',
    fieldName: 'alcoholHabits.startConsumeAlcohol',
    options:
      GENERAL_VARIABLE_DATA['alcoholHabits.startConsumeAlcohol']?.options ?? []
  },
  'alcoholHabits.typeOfAlcohol': {
    title: 'Type of Alcohol',
    fieldName: 'alcoholHabits.typeOfAlcohol',
    placeholderOther: 'Other Alcohol',
    options: GENERAL_VARIABLE_DATA['alcoholHabits.typeOfAlcohol']?.options ?? []
  },
  'alcoholHabits.amountOfAlcohol': {
    title: 'Average number of alcoholic drinks',
    fieldName: 'alcoholHabits.amountOfAlcohol',
    options:
      GENERAL_VARIABLE_DATA['alcoholHabits.amountOfAlcohol']?.options ?? []
  }
};
